import { render } from "./UiModalHeader.vue?vue&type=template&id=5fb4a613"
import script from "./UiModalHeader.vue?vue&type=script&lang=js"
export * from "./UiModalHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__